<p-card>
    <p-table [value]="echolist" [tableStyle]="{'min-width': '50rem'}" #dt
        [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]" [loading]="loading"
        [paginator]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [globalFilterFields]="['instrument','dPlate','mmPlate','pLVPlate','aPlate','sPlate']" [columns]="cols"
        stateStorage="local" stateKey="echolist-state">
        <ng-template pTemplate="caption">
            <div class="flex">
                <button pButton type="button" label="Clear" class="p-button-outlined" icon="pi pi-filter-slash" (click)="clear(dt)"></button>
                <button type="button" pButton icon="pi pi-file" iconPos="left" label="Export" (click)="dt.exportCSV()" style="margin-left: 0.5em;"></button>
                <span class="p-input-icon-left ml-auto">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="applyFilterGlobal($event, 'contains')" placeholder="Search keyword" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr> 
                <th pSortableColumn="instrument" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Echo Instrument
                        <p-sortIcon field="instrument"></p-sortIcon>
                        <p-columnFilter type="text" field="instrument" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="dPlate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        D Plate
                        <p-sortIcon field="dPlate"></p-sortIcon>
                        <p-columnFilter type="text" field="dPlate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="mmPlate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        MM Plate
                        <p-sortIcon field="mmPlate"></p-sortIcon>
                        <p-columnFilter type="text" field="mmPlate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="plvPlate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        PLV Plate
                        <p-sortIcon field="plvPlate"></p-sortIcon>
                        <p-columnFilter type="text" field="plvPlate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="aPlate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        A Plate
                        <p-sortIcon field="aPlate"></p-sortIcon>
                        <p-columnFilter type="text" field="aPlate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="sPlate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        S Plate
                        <p-sortIcon field="sPlate"></p-sortIcon>
                        <p-columnFilter type="text" field="sPlate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="startDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Start Date
                        <p-sortIcon field="startDate"></p-sortIcon>
                        <p-columnFilter type="date" field="startDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="echoIncident" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Last Echo Incident
                        <p-sortIcon field="echoIncident"></p-sortIcon>
                        <p-columnFilter type="text" field="echoIncident" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="echoIncidentDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Last Echo Incident Date
                        <p-sortIcon field="echoIncidentDate"></p-sortIcon>
                        <p-columnFilter type="date" field="echoIncidentDate" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="echoService" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Last Echo Service
                        <p-sortIcon field="echoService"></p-sortIcon>
                        <p-columnFilter type="text" field="echoService" display="menu"></p-columnFilter>
                    </div>
                </th>
                <th pSortableColumn="echoServiceDate" style="min-width:10rem">
                    <div class="flex justify-content-center align-items-center">
                        Last Echo Service Date
                        <p-sortIcon field="echoServiceDate"></p-sortIcon>
                        <p-columnFilter type="date" field="echoServiceDate" display="menu"></p-columnFilter>
                    </div>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-echo>
            <tr (click)="rowClick(echo)">
                <td>{{echo.instrument}}</td>
                <td>{{echo.dPlate}}</td>
                <td>{{echo.mmPlate}}</td>
                <td>{{echo.plvPlate}}</td>
                <td>{{echo.aPlate}}</td>
                <td>{{echo.sPlate}}</td>
                <td>{{echo.startDate | date:'short'}}</td>
                <td>{{echo.echoIncident}}</td>
                <td>{{echo.echoIncidentDate | date:'short'}}</td>
                <td>{{echo.echoService}}</td>
                <td>{{echo.echoServiceDate | date:'short'}}</td>
            </tr>
        </ng-template>
    </p-table>
</p-card>